// src/admin/AdminNav/pages/DoneOrders.jsx
import React, {useEffect, useState} from "react";
import {supabase} from "../../../../supabaseClient";
import "./DoneOrders.css";

const DoneOrdersPage = () => {
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const fetchDoneOrders = async () => {
            const {data, error} = await supabase
                .from("orders")
                .select("id, user_id, phoneNumber, deliveryAddress, deliveryName, order_created")
                .eq("done", true)
                .order("order_created", {ascending: false});

            if (error) {
                console.error("Error fetching done orders:", error);
            } else {
                setOrders(data);
            }
        };

        fetchDoneOrders();
    }, []);

    return (
        <div className="orders-page">
            <h2>Färdiga Beställningar</h2>
            <div className="orders-table">
                <div className="table-header">
                    <span>ID</span>
                    <span>Användar-ID</span>
                    <span>Telefonnummer</span>
                    <span>Leveransadress</span>
                    <span>Leveransnamn</span>
                    <span>Skapad</span>
                    <span>Status</span>
                </div>
                {orders.map((order) => (
                    <div key={order.id} className="table-row">
                        <span>{order.id}</span>
                        <span>{order.user_id}</span>
                        <span>{order.phoneNumber}</span>
                        <span>{order.deliveryAddress}</span>
                        <span>{order.deliveryName}</span>
                        <span>{new Date(order.order_created).toLocaleString()}</span>
                        <span className="status-done">Klar</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DoneOrdersPage;
